import { Component, OnInit } from '@angular/core';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';

import { CBMError, Contract, FcdProvider } from 'app/models';
import { ContractType } from 'app/models/enums';
import {
  AuthorizationService,
  ContractService,
  DownloadService,
  FcdProviderService,
  HttpService,
  MstService
} from 'app/services';
import { DownloadExportTaskBase } from 'app/shared/export/downloadExportTaskBase';

@Component({
  selector: 'app-export-mst',
  templateUrl: './export-mst.component.html',
  styleUrls: ['./export-mst.component.scss']
})
export class ExportMstComponent extends DownloadExportTaskBase implements OnInit {
  public contracts: Contract[];
  public fcdProviders: FcdProvider[];
  public selectedValue: string;

  constructor(
    private readonly contractService: ContractService,
    private readonly fcdProviderService: FcdProviderService,
    private readonly mstService: MstService,
    private readonly authorizationService: AuthorizationService,
    httpService: HttpService,
    downloadService: DownloadService
  ) {
    super(httpService, downloadService);
  }

  ngOnInit() {
    if (this.authorizationService.isMapAdmin()) {
      this.fcdProviderService.getFcdProviders().subscribe(
        (providers: FcdProvider[]) => {
          this.fcdProviders = providers ? providers : [];
        },
        (errors: CBMError[]) => {
          this.errorMessages = errors;
        }
      );
    }

    if (this.authorizationService.isLocationAdmin()) {
      this.contractService.getContracts().subscribe(
        contracts => {
          this.contracts = contracts ? contracts.filter(c => c.contractType !== ContractType.FCD) : [];
        },
        (errors: CBMError[]) => {
          this.errorMessages = errors;
        }
      );
    }
  }

  public downloadMstFile(soapEnvelope: boolean): void {
    this.setDownloading(true);
    this.errorMessages = [];
    const value = this.selectedValue.split('-');
    let downloadFile: Observable<Response>;

    if (value[0] === 'c') {
      const contractId = value[1];
      downloadFile = this.mstService.downloadMst(Number(contractId), soapEnvelope);
      this.handleTaskAsync(downloadFile);
    } else {
      const fcdProviderId = value[1];
      downloadFile = this.mstService.downloadMstFcd(Number(fcdProviderId));
      this.handleTaskAsync(downloadFile);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/export/mst/export-mst.component.ts